<template>
  <b-container v-if="group" class="p-3" fluid>
    <b-row>
      <b-col>
        <b-card class="mb-4">
          <div class="ml-auto">
            <b-button variant="primary" :to="{ name: 'settings.groups.edit', params: { id: group.id }}">
              <font-awesome-icon icon="edit" />แก้ไขหน่วยงาน
            </b-button>
          </div>
        </b-card>

        <h5>ข้อมูลหน่วยงาน</h5>
        <b-card class="mb-4">
          <dl class="row">
            <dt class="col-md-2 nowrap">ประเภท</dt>
            <dd class="col-md-9">{{ typeName }}</dd>
            <template v-if="group.parent">
              <dt class="col-md-2 nowrap">สังกัด</dt>
              <dd class="col-md-9">{{ group.parent.name }}</dd>
            </template>
            <dt class="col-md-2 nowrap">ชื่อหน่วยงาน</dt>
            <dd class="col-md-9"><strong>{{ group.name }}</strong></dd>
            <dt class="col-md-2 nowrap">สถานะ</dt>
            <dd class="col-md-9">
              <strong :class="group.isEnabled ? 'text-success' : 'text-danger'">
                {{ group.isEnabled ? 'เปิดใช้งาน' : 'ปิดการใช้งาน' }}
              </strong>
            </dd>
            <template v-if="group.isEnabled === true">
              <template v-if="group.type !== 'Council'">
                <dt class="col-md-2 nowrap">ประธานหน่วยงาน</dt>
                <dd class="col-md-9 my-auto">
                  {{ group.headOfGroup ? `${group.headOfGroup.user.thFullName} (${group.headOfGroup.user.username})` : '' }}
                  <a v-b-modal.add-hog-modal href="#">กำหนดประธานหน่วยงาน</a>
                </dd>
              </template>
              <template v-else>
                <dt class="col-md-2 nowrap">เจ้าหน้าที่สภานักศึกษา</dt>
                <dd class="col-md-9 my-auto">
                  {{ group.headOfGroup ? `${group.headOfGroup.user.thFullName} (${group.headOfGroup.user.username})` : '' }}
                  <a v-b-modal.add-hog-modal href="#">กำหนดเจ้าหน้าที่สภานักศึกษา</a>
                </dd>
              </template>
            </template>
          </dl>
          <template v-if="group.isEnabled === true">
            <hr>
            <dl class="row">
              <dt class="col-md-2 nowrap my-auto">ที่ปรึกษา</dt>
              <dd class="col-md-9 my-auto">
                {{ group.advisor ? `${group.advisor.user.thFullName} (${group.advisor.user.username})` : '' }}
                <a v-b-modal.modal-2 href="#">กำหนดที่ปรึกษา</a>
              </dd>
            </dl>
          </template>
        </b-card>

        <h5 class="border-bottom mb-3">รายชื่อผู้ประสานงาน</h5>

        <template v-for="year in usersByYear">
          <div :key="year.id" class="mb-4">
            <h6>
              ปีการศึกษา {{ year.year }}

              <b-button v-b-modal.modal-1 variant="outline-primary" size="sm" class="ml-2" @click="addingToAcYear = year">
                <font-awesome-icon icon="plus-circle" />เพิ่มรายชื่อผู้ประสานงาน
              </b-button>
            </h6>
            <response-list-table :year-id="year.id" :coordinators="year.users" :group="$route.params.id" @finish="refetch" />
          </div>
        </template>

        <div class="mb-3">
          <h6>
            ไม่ระบุปีการศึกษา (เห็นโครงการจากทุกปี)
          </h6>
          <response-list-table :year-id="''" :coordinators="usersWithoutYear" :group="$route.params.id" @finish="refetch" />
        </div>

        <!-- <b-card v-if="group.isEnabled === true" no-body>
          <h6 slot="header" class="mb-0">
            <font-awesome-icon icon="info" />รายชื่อผู้ประสานงาน
          </h6>
          <response-list-table :coordinators="group.coordinators" :group="this.$route.params.id" @finish="refetch" />
          <em slot="footer">
            <div class="text-center">
              <b-button v-b-modal.modal-1 variant="primary">
                <font-awesome-icon icon="plus-circle" />เพิ่มรายชื่อผู้ประสานงาน
              </b-button>
            </div>
          </em>
        </b-card> -->

        <add-coordinator-modal :adding-to-ac-year="addingToAcYear" @finish="$apollo.queries.group.refetch()" />
        <add-advisor-modal @finish="$apollo.queries.group.refetch()" />
        <add-head-of-group-modal @finish="$apollo.queries.group.refetch()" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ResponseListTable from '@/components/settings/groups/ResponseListTable'
import AddCoordinatorModal from '@/components/settings/groups/AddCoordinatorModal'
import AddAdvisorModal from '@/components/settings/groups/AddAdvisorModal'
import AddHeadOfGroupModal from '@/components/settings/groups/AddHeadOfGroupModal'

import gql from 'graphql-tag'

export default {
  apollo: {
    acYears: {
      query: gql`{ acYears(page:1, count:100) { data { id, year, startAt, endAt } } }`,
      fetchPolicy: 'no-cache'
    },
    group: {
      query: gql`query GetGroup($id: ID!) { group(id: $id) { id, name, type, department, chiefName, parent, isEnabled, coordinators { acYear { id }, user { username, thFullName, role } }, advisorTel, advisor { user { username thFullName } }, headOfGroup { user { username thFullName } } } }`,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  components: {
    ResponseListTable,
    AddCoordinatorModal,
    AddAdvisorModal,
    AddHeadOfGroupModal
  },
  data: function () {
    return {
      addingToAcYear: null
    }
  },
  computed: {
    typeName: function () {
      if (this.group.type === 'Club') {
        return 'ชมรม'
      } else if (this.group.type === 'Association') {
        return 'สโมสร'
      } else if (this.group.type === 'Group') {
        return 'ชุมนุม'
      } else if (this.group.type === 'StudentCouncil') {
        return 'สโมสรนักศึกษา'
      } else if (this.group.type === 'StudentUnion') {
        return 'องค์การนักศึกษา'
      } else if (this.group.type === 'PeopleGroup') {
        return 'กลุ่ม'
      } else if (this.group.type === 'Council') {
        return 'สภา'
      } else {
        return ''
      }
    },
    usersByYear: function () {
      let yearWithUsers = this.acYears.data.map(year => ({
        ...year,
        users: this.group.coordinators.filter(role => role.acYear && role.acYear.id === year.id)
      }))
      return yearWithUsers.sort((a, b) => a.year - b.year).reverse()
    },
    usersWithoutYear: function () {
      if (!this.group.coordinators.filter(role => !role.acYear)) {
        return []
      }

      return this.group.coordinators.filter(role => !role.acYear)
    }
  },
  methods: {
    refetch () {
      this.$apollo.queries.acYears.refetch()
      this.$apollo.queries.group.refetch()
    }
  }
}
</script>
